import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { modalsActions } from '../../actions';
import styles from './Modals.module.sass';
import closeIcon from '../../../../images/icons/close.svg';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

function ReactModal(props) {
  const { isOpen, children, closeModal } = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayClassName={styles.overlay}
      className={styles.content}
    >
      <div className={styles.wrapper}>
        <ClickableDiv className={styles.close} onClick={closeModal}>
          <img src={closeIcon} alt="close" />
        </ClickableDiv>
        {children}
      </div>
    </Modal>
  );
}

ReactModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(modalsActions.closeModal()),
});

export default connect(null, mapDispatchToProps)(ReactModal);
